import { red } from "@material-ui/core/colors"
import { createTheme, ThemeProvider } from "@material-ui/core/styles"

import Button from "@material-ui/core/Button"

import { theme as appTheme } from "components/ThemeProvider"

const theme = createTheme({
    ...appTheme,
    palette: {
        primary: red
    }
})

const DangerButton = props => {
    return (
        <ThemeProvider theme={theme}>
            <Button color="primary" {...props} />
        </ThemeProvider>
    )
}

export default DangerButton
